export function saveAsPicture(canvasRef: any, name: string): string {
  const fileName = name + (name.toLowerCase().endsWith(".png") ? "" : ".png");

  canvasRef.toBlob(
    (blob: Blob) => {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.target = "_blank";
      setTimeout(() => {
        a.click();
      });
    },
    "image/png",
    1,
  );

  return fileName;
}

/**
 * Illegal chars  because they are used as directory or drive letter separators
 * or make searching for the file with a glob expression hard.
 * The char ; has the effect to split the filename upon download.
 * The char ' does fail the download for an unknwown reason.
 */
const illegalFilenameCharactersReg = /[;',:\\/?*"|<>]/;
export const illegalFilenameCharactersRegExp = new RegExp(illegalFilenameCharactersReg, "g");

/**
 * Test if the filename contains illegal characters.
 * @return true if the name is not illegal for a filesystem
 */

export function validFileName(name: string): boolean {
  return !name.match(illegalFilenameCharactersRegExp);
}

/**
 * Replace all illegal characters with '_' in the filename.
 * @return name with all illegal chars replaced by '_'
 */
export function sanitizeFilename(name: string): string {
  return name.replace(illegalFilenameCharactersRegExp, "_");
}

export function createRandomFileKey() {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < 20) {
    // 32 characters long
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}
